import React from 'react';

/** 인라인 SVG 아이콘.
 *
 * 예전에는 파일마다 SvgBase 를 복사해 두었는데, 그러면 굵기·선끝 규칙이
 * 한 곳만 바뀌어도 화면마다 어긋납니다. 뼈대는 여기 한 벌만 둡니다.
 * (이모지는 쓰지 않습니다 — 기기마다 모양이 달라 규율이 무너집니다)
 */
export const SvgBase: React.FC<React.PropsWithChildren<{ size?: number; color?: string; strokeWidth?: number }>> = ({
    size = 16, color = 'currentColor', strokeWidth = 1.8, children,
}) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke={color}
         strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        {children}
    </svg>
);

type P = { size?: number; color?: string; strokeWidth?: number };

/** 위치 공유 중 — 핀 */
export const IconPin = (p: P) => (
    <SvgBase {...p}>
        <path d="M12 21s7-5.7 7-11a7 7 0 1 0-14 0c0 5.3 7 11 7 11z" />
        <circle cx="12" cy="10" r="2.6" />
    </SvgBase>
);

/** 위치 미공유 — 핀에 사선. 상태를 색이 아니라 모양으로 읽히게 합니다 */
export const IconPinOff = (p: P) => (
    <SvgBase {...p}>
        <path d="M12 21s7-5.7 7-11a7 7 0 1 0-14 0c0 5.3 7 11 7 11z" />
        <circle cx="12" cy="10" r="2.6" />
        <path d="M4 4l16 16" />
    </SvgBase>
);

/** 지도 보기 — 접힌 지도 */
export const IconMap = (p: P) => (
    <SvgBase {...p}>
        <path d="M9 4.5 3.5 6.8v12.7L9 17.2l6 2.3 5.5-2.3V4.5L15 6.8 9 4.5z" />
        <path d="M9 4.5v12.7M15 6.8v12.7" />
    </SvgBase>
);

/** 공유 — 세 점 잇기 */
export const IconShare = (p: P) => (
    <SvgBase {...p}>
        <circle cx="18" cy="5" r="3" />
        <circle cx="6" cy="12" r="3" />
        <circle cx="18" cy="19" r="3" />
        <path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" />
    </SvgBase>
);

/** 사람 여럿 — 참여자 */
export const IconUsers = (p: P) => (
    <SvgBase {...p}>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </SvgBase>
);

/** 오른쪽 꺾쇠 — 더 보기 */
export const IconChevronRight = (p: P) => (
    <SvgBase strokeWidth={2.2} {...p}>
        <polyline points="9 18 15 12 9 6" />
    </SvgBase>
);
